module.exports = __webpack_public_path__ + "img/frawla.ee2dd0fd.png";